import { useEffect, useRef } from 'react';
import type { SelectedOverlayElement } from './useOverlaySelection';

/**
 * Element mode — "Overlay controls hide on element selection" (2026-10-27).
 *
 * While an element is selected, the overlay controls (the corner pucks,
 * Templates, Aspect ratio, Record, Play, Mute, Fit/Fill) are gone — not
 * faded, not rendered — so whatever sits under them (a logo in the corner)
 * can be worked with. Selecting also closes whatever control was open.
 *
 * Returns the flag the editor gates its controls on. `onEnter` runs once per
 * selection (a new element, not a re-render of the same one) and never on
 * deselect: nothing reopens by itself when the element is let go. The
 * editor passes the closers it has (open corner, Fit/Fill, strips, menus).
 */
export function useElementMode(selected: SelectedOverlayElement | null, onEnter: () => void): boolean {
  const onEnterRef = useRef(onEnter);
  onEnterRef.current = onEnter;
  useEffect(() => {
    if (selected) onEnterRef.current();
  }, [selected]);
  return selected != null;
}
